
    <div class="flex justify-content-start align-items-start" *ngIf="!processing">
        <!--div class="col-6 flex justify-content-start" [hidden]="hideTimer">
          <p [hidden]="hideTimer">Tiempo restante para confirmacion:</p>
        </div-->
        <div class="col-6 flex justify-content-center align-items-center w-full">
          <div>
            {{ days }} 
            <span *ngIf="isShortText">{{'Timer.DaysShortText' | translate}}, </span>
            <span *ngIf="!isShortText">{{'Timer.DaysText' | translate}}, </span>

            {{hours}} 
            <span *ngIf="isShortText">{{'Timer.HoursShortText' | translate}}, </span>
            <span *ngIf="!isShortText">{{'Timer.HoursText' | translate}}, </span>

            {{minutes}} 
            <span *ngIf="isShortText">{{'Timer.MinutesShortText' | translate}}</span>
            <span *ngIf="!isShortText">{{'Timer.MinutesText' | translate}}</span>

            <span *ngIf="showSeconds">, {{ seconds }} {{'Timer.SecondsText' | translate}}</span>
        </div>
    </div>
    <div *ngIf="processing" class="col-6 flex justify-content-start align-items-start">
      <p>{{'Timer.CalculatedText' | translate}}</p>
    </div>
